import React, { useState } from "react";
import { Modal } from "carbon-components-react";
import { connect } from "react-redux";

import { LenderCredit } from "@eave/shared/types/api";
import { thereWasAProblem } from "@eave/shared/utils/alerts";

import APIClient from "web_modules/APIClient";
import { LoadingState } from "underwriter_dashboard/shared/types";
import BaseTable, { EditingState } from "web_modules/shared/BaseTable";
import { loadApp } from "underwriter_dashboard/actions";
import { dollarsTo2Places } from "underwriter_dashboard/hurdle_editors/SandboxScenario/SandboxScenarioCalculator/helpers";

import { initialValues } from "./FormValues";
import AddLenderCreditsForm from "./AddLenderCreditsForm";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

const LenderCredits = ({
  refreshApp,
  appId,
  lenderCredits,
}: {
  refreshApp: any;
  appId: number;
  lenderCredits: LenderCredit[];
}) => {
  const [editingMode, updateEditingMode] = useState(EditingState.CREATE);

  const [formOpen, updateFormOpen] = useState(false);
  const [formState, updateFormState] = useState(initialValues(appId));

  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  return (
    <>
      <BaseTable
        key="lender-credits"
        title="Lender Credits"
        // deleteActionText="Activate"
        disableBatchEdit
        allowHeaderTextWrapping
        disableBatchDelete
        disableBatch
        rowHeight="short"
        useZebraStyles
        // disableAddNew
        openModal={() => updateFormOpen(true)}
        updateFormState={data => updateFormState(data)}
        updateEditingMode={updateEditingMode}
        headerData={[
          { header: "Description", key: "description" },
          { header: "Amount", key: "amount" },
        ]}
        rawRowData={lenderCredits}
        rowData={lenderCredits.map((credit: LenderCredit) => ({
          ...credit,
          amount: dollarsTo2Places(Number(credit.amount)),
        }))}
        // collapseOverride
        openDeleteModal={() => setDeleteModalIsOpen(true)}
      />
      <Modal
        className={`${styles.patchModalBottomPaddingIssue} ${styles.patchModalTooltipZIndex}`}
        passiveModal
        open={formOpen}
        modalHeading={
          editingMode === EditingState.CREATE ? "Add lender credit" : "Update lender credit"
        }
        selectorPrimaryFocus="#role"
        onRequestClose={() => {
          updateFormOpen(false);
          updateFormState(initialValues(appId));
        }}
        onBlur={() => {
          updateFormOpen(false);
          updateFormState(initialValues(appId));
        }}
      >
        <AddLenderCreditsForm
          formState={formState}
          onSubmit={async (credit: LenderCredit) => {
            let promise;
            const { amount, description } = credit;
            try {
              if (credit.id === 0) {
                promise = APIClient.post(
                  `/uw/loan_applications/${credit.loan_application_id}/lender_credit`,
                  { description, amount },
                );
              } else {
                promise = APIClient.put(
                  `/uw/loan_applications/${credit.loan_application_id}/lender_credit/${credit.id}`,
                  { description, amount },
                );
              }

              await promise;
              refreshApp(appId);
            } catch (e) {
              thereWasAProblem("saving the lender credit");
              throw e;
            } finally {
              updateFormOpen(false);
              updateFormState(initialValues(appId));
            }
          }}
          editingMode={editingMode}
          onRequestClose={() => {
            updateFormOpen(false);
            updateFormState(initialValues(appId));
          }}
          loading={LoadingState.FINISHED}
        />
      </Modal>
      <Modal
        className={styles.patchModalBottomPaddingIssue}
        danger
        open={deleteModalIsOpen}
        modalHeading="Are you sure you'd like to delete this lender credit?"
        primaryButtonText="Delete"
        secondaryButtonText="Cancel"
        onBlur={() => setDeleteModalIsOpen(false)}
        onRequestClose={() => setDeleteModalIsOpen(false)}
        onRequestSubmit={async () => {
          try {
            await APIClient.deleteRequest(
              `/uw/loan_applications/${formState.loan_application_id}/lender_credit/${formState.id}`,
            );

            refreshApp(appId);
          } catch (e) {
            thereWasAProblem("saving the lender credit");
            throw e;
          } finally {
            setDeleteModalIsOpen(false);
            updateFormState(initialValues(appId));
          }
        }}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  refreshApp: (appId: number) => loadApp(dispatch, appId),
});

export default connect(null, mapDispatchToProps)(LenderCredits);
